import service from '@/services/reviewRequests';

export default {
  loadReviewRequests: ({ commit, state }, { onlyWithCoupons, ...payload } = {}) => {
    return service
      .getReviewRequestsDatatables({ onlyWithCoupons, ...state.reviewRequests.pagination }, payload)
      .then(response => commit('loadReviewRequestsSuccess', response));
  },
  setPagination({ commit }, payload) {
    return commit('setPagination', payload);
  },
  sendNow: ({ commit }, { orderId, sendSms }) => {
    //820 notes: unused variable removed
    return service
      .sendNow(orderId, sendSms)
      .then(() => {
        commit(
          'showToast',
          {
            color: 'toast_default',
            text: 'ReviewRequests.sendNowSuccess',
          },
          {
            root: true,
          }
        );
        return commit('sendNowSuccess', orderId);
      })
      .catch(() => {
        commit(
          'showToast',
          {
            color: 'toast_error',
            text: 'ReviewRequests.sendNowError',
          },
          {
            root: true,
          }
        );
      });
  },
  cancel: ({ commit }, orderId) => {
    //820 notes: unused variable removed
    return service
      .cancel(orderId)
      .then(() => {
        commit(
          'showToast',
          {
            color: 'toast_default',
            text: 'ReviewRequests.cancelSuccess',
          },
          {
            root: true,
          }
        );
        return commit('cancelSuccess', orderId);
      })
      .catch(() => {
        return commit(
          'showToast',
          {
            color: 'toast_error',
            text: 'ReviewRequests.sendNowError',
          },
          {
            root: true,
          }
        );
      });
  },
  reschedule: ({ commit }, reviewRequestId) => {
    //820 notes: unused variable removed
    return service
      .reschedule(reviewRequestId)
      .then(() => {
        commit(
          'showToast',
          {
            color: 'toast_default',
            text: 'ReviewRequests.sendNowSuccess',
          },
          {
            root: true,
          }
        );
      })
      .catch(() => {
        commit(
          'showToast',
          {
            color: 'toast_error',
            text: 'ReviewRequests.sendNowError',
          },
          {
            root: true,
          }
        );
      });
  },
  loadReviewRequestsPerMonth: context => {
    service
      .getReviewRequestsPerMonth()
      .then(response => {
        return context.commit('loadReviewRequestsPerMonthSuccess', response);
      })
      .catch(err => {
        return context.commit(
          'showToast',
          {
            color: 'toast_error',
            text: err,
          },
          {
            root: true,
          }
        );
      });
  },
  sendReviewRequestsByMonth: ({ commit }, payload) => {
    return service
      .sendReviewRequestsByMonth(payload)
      .then(() => {
        return commit(
          'showToast',
          {
            color: 'toast_default',
            text: 'ReviewRequests.sendOldSuccess',
          },
          {
            root: true,
          }
        );
      })
      .catch(() => {
        return commit(
          'showToast',
          {
            color: 'toast_error',
            text: 'ReviewRequests.bulkError',
          },
          {
            root: true,
          }
        );
      });
  },
  scheduleReviewRequestForOrder: ({ commit }, payload) => {
    //820 notes: unused variable removed
    commit(
      'showToast',
      {
        color: 'toast_default',
        text: 'ReviewRequests.scheduledSuccess',
      },
      {
        root: true,
      }
    );
    return service
      .scheduleReviewRequestForOrder(payload)
      .then(res => {
        commit('setCreditsLeft', res.data.creditsLeft, { root: true });
      })
      .catch(() => {
        return commit(
          'showToast',
          {
            color: 'toast_error',
            text: 'ReviewRequests.sendNowError',
          },
          {
            root: true,
          }
        );
      });
  },
};
